import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { Image } from '../../components/Image';
import { GlobalContext } from '../../contexts/HomeContext';
import './styles.css';

export const Cardapio = () => {
  const { dadosApp } = useContext(GlobalContext);
  const navigate = useNavigate();

  const handleItemClick = (id) => {
    navigate('/loja/' + id + '?selected=' + true);
  };

  useEffect(() => {
    if (dadosApp.IdLoja === 0 || dadosApp.Empresa.Mult.lenth === 0) {
      //navigate.goBack();
      navigate(-1);
    }
  }, [dadosApp, navigate]);
  return (
    // style={{
    //   backgroundImage: `url("http://www.sujinho.com.br/images/bg_hamb.jpg")`,
    // }}
    <div>
      <div style={{ backgroundColor: '#e3262e', minHeight: '4.6875rem' }}>
        <h4 className="title-category" style={{ color: 'white', textAlign: 'center', padding: 17 }}>
          Selecione o Cardápio
        </h4>
      </div>
      <div className="container margin_detail">
        <div className="row">
          <div className="col-lg-12">
            <section className="page-section">
              <div className="row">
                {dadosApp.Empresa.Mult.map((empresa, index) => {
                  const _descricao = empresa.fantasia_edicao === '' ? empresa.fantasia : empresa.fantasia_edicao;

                  return (
                    <div className="col-md-6" id={index} key={empresa.id}>
                      <a className="menu_item" onClick={() => handleItemClick(empresa.codigo_sistema)}>
                        {!empresa.logo && (
                          <div>
                            <h3>{_descricao.toLowerCase()}</h3>
                            <p style={{ textTransform: 'capitalize', marginTop: 5 }}>
                              {empresa.endereco.toLowerCase()}, {empresa.endereco_numero}
                            </p>
                            <p style={{ color: '#e3262e', fontWeight: 'bold', textTransform: 'capitalize' }}>
                              {empresa.endereco_bairro.toLowerCase()}
                            </p>
                            {/* <div>
                              <figure>
                                <img
                                  src={'http://www.sujinho.com.br/Sujinho/images/logo_sujinho.png'}
                                  style={{ width: 90, height: 90 }}
                                />
                              </figure>
                            </div> */}
                          </div>
                        )}
                        {!!empresa.logo && (
                          <div>
                            <div className="item_descricao">
                              <h3>{_descricao.toLowerCase()}</h3>
                              <p style={{ textTransform: 'capitalize', marginTop: 5 }}>
                                {empresa.endereco.toLowerCase()}, {empresa.endereco_numero}
                              </p>
                              <p style={{ color: '#e3262e', fontWeight: 'bold', textTransform: 'capitalize' }}>
                                {empresa.endereco_bairro.toLowerCase()}
                              </p>
                            </div>
                            <div>
                              <Image src={empresa.logo} alt={_descricao.toLowerCase()} size={90} />
                            </div>
                          </div>
                        )}
                      </a>
                    </div>
                  );
                })}
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};
